import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Col, Row } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCoins } from "@fortawesome/free-solid-svg-icons";

const STATUS_LABELS = {
  done: "Listo",
  current: "Siguiente paso",
  upcoming: "Pendiente",
};

const stepState = (step, number, current) => {
  if (step.done) return "done";
  return number === current ? "current" : "upcoming";
};

const PlanillaSteps = ({ steps, current }) => (
  <Row noGutters>
    {steps.map((step, index) => {
      const number = index + 1;
      const state = stepState(step, number, current);

      return (
        <Col key={step.key} xs={12} lg={4} className="mb-2 mb-lg-0 px-lg-1">
          <div
            className={classNames(
              "h-100 rounded border p-2 d-flex flex-column flex-sm-row flex-lg-column align-items-stretch align-items-sm-center align-items-lg-stretch",
              {
                "border-primary bg-soft-primary": state === "current",
                "border-success": state === "done",
              }
            )}
          >
            <div className="d-flex align-items-start flex-grow-1" style={{ minWidth: 0 }}>
              <span
                className={classNames(
                  "rounded-circle d-flex align-items-center justify-content-center font-weight-bold fs--1 mr-2",
                  {
                    "bg-primary text-white": state === "current",
                    "bg-success text-white": state === "done",
                    "bg-200 text-600": state === "upcoming",
                  }
                )}
                style={{ width: 26, height: 26, minWidth: 26 }}
              >
                {state === "done" ? <FontAwesomeIcon icon={faCheck} /> : number}
              </span>
              <div className="flex-grow-1" style={{ minWidth: 0 }}>
                <div className="d-flex flex-wrap align-items-center">
                  <h6 className="mb-0 fs--1 mr-1">{step.title}</h6>
                  <span
                    className={classNames("badge badge-pill fs--2", {
                      "badge-soft-success": state === "done",
                      "badge-soft-primary": state === "current",
                      "badge-soft-secondary": state === "upcoming",
                    })}
                  >
                    {STATUS_LABELS[state]}
                    {state === "done" && step.doneDetail ? ` · ${step.doneDetail}` : ""}
                  </span>
                </div>
                <small className="d-block text-600 fs--2 mt-1">
                  {step.description}
                </small>
                {step.note && (
                  <small className="d-block text-primary fs--2 mt-1">
                    <FontAwesomeIcon icon={faCoins} className="mr-1" />
                    {step.note}
                  </small>
                )}
              </div>
            </div>
            {state !== "done" && (
              <div className="flex-shrink-0 mt-2 mt-sm-0 ml-sm-2 mt-lg-2 ml-lg-0">
                {step.renderAction(state)}
              </div>
            )}
          </div>
        </Col>
      );
    })}
  </Row>
);

PlanillaSteps.propTypes = {
  current: PropTypes.number.isRequired,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      done: PropTypes.bool,
      doneDetail: PropTypes.string,
      note: PropTypes.string,
      renderAction: PropTypes.func.isRequired,
    })
  ).isRequired,
};

export default PlanillaSteps;
